export const SECONDS_IN_DAY = 86400;
export const SECONDS_IN_THIRTY_DAYS = SECONDS_IN_DAY * 30;
export const SECONDS_IN_SIX_MONTHS = SECONDS_IN_DAY * 180;

// Get a value from cookie.
export const getCookieValue = (key, json = false) => {
  const name = `${key}=`;

  const cookies = document.cookie ? document.cookie.split(";") : [];
  let cookieValue = null;

  cookies?.forEach(item => {
    const cookie = item.trim();

    if (cookie.indexOf(name) === 0) {
      const strValue = cookie.substring(name.length, cookie.length);
      cookieValue = json && strValue ? JSON.parse(strValue) : strValue;
    }
  });

  return cookieValue;
};

export const setCookieValue = (
  key,
  value,
  ttlInSeconds,
  path = "/",
  json = true
) => {
  const maxAgeString = `max-age=${ttlInSeconds}`;
  const stringValue = json ? JSON.stringify(value) : value;

  if (document) {
    document.cookie = `${key}=${stringValue};${maxAgeString};path=${path}`;
  }

  return true;
};
